export default __webpack_public_path__ + "static/media/Mk.5a841157.jpg";